// extracted by mini-css-extract-plugin
export default {"bcIcon":"bcIcon_jFDEE","iconContainer":"iconContainer_VyQ3d","i8":"i8_cff6r","i16":"i16_oJqvY","i24":"i24_l8qjh","i32":"i32_U1OXd","i48":"i48_fFVIW","i64":"i64_heEd7"};